import React, { useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'cropperjs/dist/cropper.css';
import Cropper from 'react-cropper';
import "../../src/App.css";

function FileUpload() {
  const [imageURL, setImageURL] = useState(null);
  const [processedImageURL, setProcessedImageURL] = useState(null);
  const [file, setFile] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState('#ffffff');
  const [isCropping, setIsCropping] = useState(false);
  const [isBackgroundRemoved, setIsBackgroundRemoved] = useState(false);
  const [showOriginalImage, setShowOriginalImage] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [brightness, setBrightness] = useState(100);
  const [contrast, setContrast] = useState(100);
  const cropperRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFile(file);
    const url = URL.createObjectURL(file);
    setImageURL(url);
    setProcessedImageURL(null);
    setIsCropping(false);
    setIsBackgroundRemoved(false);
    setShowOriginalImage(true);
    setIsLoading(false);
    setBrightness(100);
    setContrast(100);
  };

  const handleCrop = () => {
    const cropper = cropperRef.current.cropper;
    const croppedCanvas = cropper.getCroppedCanvas();
    croppedCanvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      setProcessedImageURL(url);
      setFile(new File([blob], 'cropped_image.png', { type: 'image/png' }));
      setIsCropping(false);
      setShowOriginalImage(true);
    });
  };

  const handleColorChange = (event) => {
    setBackgroundColor(event.target.value);
  };

  const removeBackgroundHandler = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('image_file', file);
    formData.append('size', 'auto');

    const apiKey = 'H8yzd3y11RKnGstTAJLhZE1L';

    fetch('https://api.remove.bg/v1.0/removebg', {
      method: 'POST',
      headers: {
        'X-Api-Key': apiKey
      },
      body: formData
    })
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        setProcessedImageURL(url);
        setIsBackgroundRemoved(true);
        setShowOriginalImage(false);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const changeBackgroundColorHandler = () => {
    const formData = new FormData();
    formData.append('image_file', file);
    formData.append('size', 'auto');
    formData.append('bg_color', backgroundColor.replace('#', ''));

    const apiKey = 'H8yzd3y11RKnGstTAJLhZE1L';

    fetch('https://api.remove.bg/v1.0/removebg', {
      method: 'POST',
      headers: {
        'X-Api-Key': apiKey
      },
      body: formData
    })
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        setProcessedImageURL(url);
      })
      .catch(err => console.error(err));
  };

  const downloadFile = (url) => {
    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    anchorElement.download = 'processed_image.png';
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
  };

  const retouchingHandler = (type, value) => {
    if (type === "brightness") {
      setBrightness(value);
    } else if (type === "contrast") {
      setContrast(value);
    }
  };

  return (
    <div className="container-fluid p-0 container mt-5">
      <div className="row no-gutters">
        <div className="col-md-6 left-section">
          <div className="content">
            <h2 className="text-center text-white animate__animated animate__fadeIn">UPLOAD IMGAGE</h2>
            <form>
              <div className="form-group">
                <label htmlFor="fileInput" className="text-white">Select a File:</label>
                <input
                  id="fileInput"
                  className="form-control"
                  type="file"
                  onChange={handleFileChange}
                />
              </div>
            </form>

            {imageURL && showOriginalImage && (
              <div className="text-center mt-3">
                <button className="btn btn-primary m-1 animated-button" onClick={() => { setIsCropping(true); setShowOriginalImage(false); }}>
                  Crop Image
                </button>
                <button className="btn btn-primary m-1 animated-button" onClick={() => { removeBackgroundHandler(); setShowOriginalImage(false); }}>
                  Remove Background
                </button>
              </div>
            )}

            {isBackgroundRemoved && (
              <div className="form-group mt-3 col-md-6 mx-auto text-center">
                <label htmlFor="colorInput" className="text-white">Select Background Color:</label>
                <input
                  id="colorInput"
                  className="form-control"
                  type="color"
                  value={backgroundColor}
                  onChange={handleColorChange}
                />
                <button className="btn btn-secondary mt-2 animated-button" onClick={changeBackgroundColorHandler}>
                  Change Background Color
                </button>
              </div>
            )}

            {imageURL && (
              <div className="text-center mt-3">
                <label className="text-white">Brightness</label>
                <input type="range" min="0" max="200" value={brightness} onChange={(e) => retouchingHandler("brightness", e.target.value)} />
                <label className="text-white">Contrast</label>
                <input type="range" min="0" max="200" value={contrast} onChange={(e) => retouchingHandler("contrast", e.target.value)} />
              </div>
            )}

            {processedImageURL && (
              <div className="text-center mt-3">
                <button className="btn btn-warning animated-button" onClick={() => downloadFile(processedImageURL)}>
                  Download
                </button>
              </div>
            )}
          </div>
        </div>

        {imageURL && (
          <div className="col-md-6 right-section">
            {isCropping && imageURL && (
              <div className="text-center mt-3">
                <Cropper
                  src={imageURL}
                  style={{ height: 400, width: '100%' }}
                  initialAspectRatio={1}
                  guides={false}
                  ref={cropperRef}
                />
                <button className="btn btn-primary mt-2 animated-button" type="button" onClick={handleCrop}>
                  Apply Crop
                </button>
              </div>
            )}

            {isLoading && (
              <div className="text-center mt-3">
                <div className="spinner-border text-primary" role="status"></div>
              </div>
            )}

            <div className="row mt-4 text-center">
              {imageURL && showOriginalImage && !isLoading && (
                <div className="col-md-12 animate__animated animate__zoomIn">
                  <h5>Original Image</h5>
                  <img
                    src={imageURL}
                    alt="Original"
                    className="img-fluid rounded"
                    style={{ filter: `brightness(${brightness}%) contrast(${contrast}%)` }}
                  />
                </div>
              )}
              {processedImageURL && (
                <div className="col-md-12 animate__animated animate__zoomIn">
                  <h5>Processed Image</h5>
                  <img
                    src={processedImageURL}
                    alt="Processed"
                    className="img-fluid rounded"
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FileUpload;
